module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "acknowPage"
  }, [_c('a', {
    attrs: {
      "id": "title1"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The images in this book are courtesy of the American Hockey League, Tom Army, Buster Clegg, Ernie Fitzsimmons, Roger Gladu, Lauren Peterson (executive assistant to the president of the American Hockey League), the Providence Bruins, the Rhode Island Reds Heritage Society, Tom Sersha (executive director of the United States Hockey Hall of Fame), and the United States Hockey Hall of Fame. Though the photographs were not obtained from them directly, credit is due to Providence Bruins photographers Ron Marcotte and David Silverman, who were responsible for actually taking some of the photographs featured in this publication.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("I would like to thank the American Hockey League, Kevin Boryczki (Providence Bruins manager of public relations), Ernie Fitzsimmons, and Edwin Duane Isenberg for their imaging work on the illustrations in this book.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("I was helped directly through the Providence Bruins office by Frank DuRoss (team president and owner) and Kevin Boryczki (manager of public relations).")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("I was helped directly through the Rhode Island Reds Heritage Society by founding president Buster Clegg, Tom Army, and George Patrick Duffy.")])])]), _c('p', {
    staticClass: "p-indent"
  }, [_c('a', {
    attrs: {
      "id": "title1"
    }
  }, [_c('span', [_vm._v("The statistics in this book were obtained from the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("2006 National Hockey League Official Guide and Record Book")]), _vm._v(", the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("National (Official) Hockey Guide")]), _vm._v(" edited by Jim Hendy (various years), Ralph Slate’s Hockey Database (")])]), _c('a', {
    attrs: {
      "href": "http://www.hockeydb.com",
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("www.hockeydb.com")])]), _vm._v("), the Society for International Hockey Research, and "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Total Hockey (Second Edition)—The Official Encyclopedia of the National Hockey League")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Other resources used to complete this work include "), _c('em', {
    staticClass: "i"
  }, [_vm._v("The American Hockey League Official Guide and Record Book")]), _vm._v(" (various years); Ray Clow; Ernie Fitzsimmons; "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Hockey In Springfield")]), _vm._v(" by Jim Mancuso; "), _c('em', {
    staticClass: "i"
  }, [_vm._v("The Hockey News")]), _vm._v(" (various years); "), _c('em', {
    staticClass: "i"
  }, [_vm._v("The Providence Journal")]), _vm._v(" (various years); The Rhode Island Reds Heritage Society ("), _c('a', {
    attrs: {
      "href": "http://www.rireds.org",
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("www.rireds.org")])]), _vm._v("); "), _c('em', {
    staticClass: "i"
  }, [_vm._v("The Sporting News Hockey Guide")]), _vm._v(" (various years); and Fred Zalatan.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("A special thanks to my mother Joan Mancuso, ticket sales representative at the Utica Memorial Auditorium, who got me in free to hockey games in the 1970s and early 1980s.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84b9ce1c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781439617960_ack01.vue
// module id = 72
// module chunks = 0